import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PersistConfig, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { RealtorFlatStoreType } from './models';

const initialState: RealtorFlatStoreType = {
  isProfit: false,

  print: {
    visible: false
  }
};

export const realtorFlatSlice = createSlice({
  initialState,
  name: 'realtor-flat-slice',
  reducers: {
    setRealtorFlatProfit: state => {
      state.isProfit = !state.isProfit;
    },
    setPrint: (state, actions: PayloadAction<RealtorFlatStoreType['print']>) => {
      state.print = actions.payload;
    }
  }
});

const config: PersistConfig<RealtorFlatStoreType> = {
  storage,
  whitelist: ['isProfit'],
  key: 'realtor-flat-view-profit'
};

export const realtorFlatReducer = persistReducer(config, realtorFlatSlice.reducer);
export const { setPrint, setRealtorFlatProfit } = realtorFlatSlice.actions;
